import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  navigateTo,
  UpdateGrainBinFormGql,
} from '@amber-ui/core';

function GrainBinSettingsRoute() {
  const { bin } = Route.useSearch();

  const onSubmitSuccess = useCallback(
    ({ grain_bin_id, bin_name }: { grain_bin_id: string; bin_name: string }) => {
      navigateTo('/grain_bin/dashboard', {
        container_name: bin_name,
        container_id: grain_bin_id,
        container_type: ContainerTypeLegacy.bin,
      });
    },
    []
  );

  const onSelectContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  const onArchiveClick = useCallback((selected: ContainerSelectionArgs) => {
    if (
      selected.container_type &&
      [ContainerTypeLegacy.bin, ContainerTypeLegacy.barge].includes(selected.container_type)
    ) {
      navigateTo('/user/settings', selected);
    } else {
      navigateTo('/grain/operations');
    }
  }, []);

  const goOrgSettings = useCallback(() => {
    navigateTo('/user/settings');
  }, []);

  if (!bin) return null;

  return (
    <UpdateGrainBinFormGql
      grain_bin_id={bin}
      onSubmitSuccess={onSubmitSuccess}
      url_base="/grain_bin"
      onSelectContainer={onSelectContainer}
      onArchiveClick={onArchiveClick}
      goOrgSettings={goOrgSettings}
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/settings')({
  component: GrainBinSettingsRoute,
});
